import { useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const POLL_MS_FOREGROUND = 12000;
const POLL_MS_BACKGROUND = 60000;

/**
 * useNowPlaying: polls `/api/radio/now-playing` while the radio is playing.
 * - Foreground: every 12s so the on-screen "Ora in onda" pillola stays fresh.
 * - Background (tab hidden / screen off): drops to every 60s to spare
 *   battery and mobile data during long listening sessions.
 * Fully pauses polling when the radio itself is not playing.
 */
export function useNowPlaying(active = true) {
  const [info, setInfo] = useState(null);
  const timerRef = useRef(null);
  const [hidden, setHidden] = useState(
    typeof document !== "undefined" ? document.hidden : false
  );

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const onVis = () => setHidden(document.hidden);
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchOnce = async () => {
      try {
        const res = await axios.get(`${API}/radio/now-playing`);
        if (!cancelled && res.data) setInfo(res.data);
      } catch (_e) {
        /* swallow */
      }
    };

    if (active) {
      fetchOnce();
      const pollMs = hidden ? POLL_MS_BACKGROUND : POLL_MS_FOREGROUND;
      timerRef.current = setInterval(fetchOnce, pollMs);
    }

    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [active, hidden]);

  return info;
}
